import React, {useEffect, useState} from "react";
import CustomCard from "../CustomCard";
import FormGenerator from "./FormGenerator";
import {Button} from "react-bootstrap";
import ConfirmModal from "../modal/ConfirmModal";
import {Actions} from "../../../client/Actions";
import QrCodeButton from "../qrCode/QrCodeButton";
import EditButton from "../button/EditButton";
import {useTranslation} from "react-i18next";

const CardForm = ({
                      setLoader,
                      fields,
                      qrCodeField,
                      qrCodeValue,
                      api,
                      title,
                      shadow,
                      performReload,
                      initialData,
                      additional,
                      withoutCancel,
                      customSave,
                      customCancel,
                      disableCleanAfterSave,
                      customClean,
                      reInit,
                      className,
                      withoutPadding,
                      readOnly,
                      withToggle,
                      editable,
                      onInvalid,
                      postSaved,
                      onToggleChange,
                      reverseButtons,
                      saveButton,
                      dictionaries,
                      replaceFormData,
                      withoutHeader,
                      onRemoveField,
                      noActions,
                      formDataChanged,
                      createFormDataFrom,
                      postCancel,
                      executeSave,
                      executeCancel,
                      disableInvalidAlert,
                      disableLoader,
                      width = 6
                  }) => {

    const [hideBody, setHideBody] = useState(withToggle);
    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState();
    const [ready, setReady] = useState(false);
    const [alertInvalid, setAlertInvalid] = useState(false);
    const [showAllerModal, setShowAllerModal] = useState(false);
    const [qrCodeReady, setQrCodeReady] = useState(false);
    const {t} = useTranslation();


    const saveData = () => {
        if (!disableLoader) {
            setLoader(true);
        }

        if (customSave) {
            customSave(formData, onSaved);
        } else {
            if (editMode) {
                Actions.put(api, formData, onSaved);

            } else {
                Actions.post(api, formData, onSaved);
            }
        }
    };

    const handleSave = () => {
        if (!ready) {
            setAlertInvalid(true);
            if (onInvalid) {
                onInvalid();
            }
            if (!disableInvalidAlert) {
                setShowAllerModal(true);
            }

        } else {
            saveData();
        }

    };


    const onSaved = (response) => {

        if (postSaved) {
            postSaved(formData, response);
        }


        if (customClean) {
            setFormData(customClean(formData));
            setAlertInvalid(false)
        } else if (!disableCleanAfterSave) {
            clearData();
        }


        if (editMode) {
            setEditMode(false)
        }

        if (performReload) {
            performReload();
        }


        setLoader(false);

    };

    const onCancel = () => {
        if (editMode) {
            setEditMode(false)
            reInit()
        } else {
            clearData();
        }

        if (postCancel) {
            postCancel();
        }

    };

    const clearData = () => {
        setFormData(undefined);
        setAlertInvalid(false);
    };

    const calculateQrCodeReady = () => {
        const result = !!qrCodeValue || (!!qrCodeField && !!formData && !!formData[qrCodeField] && formData[qrCodeField] !== "");

        setQrCodeReady(result);
    };


    useEffect(calculateQrCodeReady, [formData]);
    useEffect(() => {
        if (formDataChanged && !readOnly) {
            formDataChanged(formData)
        }
    }, [formData]);

    useEffect(() => {
        if (createFormDataFrom) {
            setFormData(createFormDataFrom)
        }
    }, [createFormDataFrom]);

    useEffect(() => {
            if (onToggleChange) {
                onToggleChange(!hideBody)
            }

            if (hideBody && editMode) {
                onCancel()
            }

        }, [hideBody]
    )

    useEffect(() => {
            if (!!executeSave) {
                handleSave()
            }
        }, [executeSave]
    )

    useEffect(() => {
            if (!!executeCancel) {
                onCancel()
            }
        }, [executeCancel]
    )

    useEffect(() => {
            if (replaceFormData) {
                setFormData(replaceFormData)

            }
        }, [replaceFormData]
    )


    function prepareTittle() {
        return <>
            <div className="float-left mw-85">
                {title}
            </div>
            {withToggle ?
                <div className="float-right ml-2">
                    <Button
                        variant={"outline-primary"}
                        onClick={() => setHideBody(!hideBody)}
                        className="accordion-button">


                        {!hideBody ?
                            <i className="fas fa-chevron-circle-up text-primary h5"></i> :
                            <i className="fas fa-chevron-circle-down text-primary h5"></i>
                        }
                    </Button>
                </div>
                : ""}
            {withToggle && !hideBody &&
                <div className="float-right">
                    {editable && !editMode &&
                        <EditButton
                            className={"mr-2"}
                            onClick={() => setEditMode(true)}
                            value={!editMode}
                        />
                    }
                    {(qrCodeField || qrCodeValue) &&
                        <QrCodeButton
                            disabled={!qrCodeReady}
                            value={qrCodeValue || (formData ? formData[qrCodeField] : undefined)}
                        />
                    }


                </div>
            }

        </>;
    }

    return (
        <>

            <CustomCard title={prepareTittle()}
                        shadow={shadow}
                        className={className}
                        hideBody={hideBody}
                        withoutPadding={withoutPadding}
                        withoutHeader={withoutHeader}
                        width={width}>
                <FormGenerator fields={typeof fields === 'function' ? fields(t) : fields}
                               formData={formData}
                               initData={true}
                               setFormData={setFormData}
                               setReady={setReady}
                               onRemoveField={onRemoveField}
                               localDictionaries={dictionaries}
                               alertInvalid={alertInvalid}
                               initialData={initialData}
                               setLoader={setLoader}
                               additional={additional}
                               readOnly={readOnly || (editable && !editMode)}/>


                {!readOnly && (reInit ? editMode : true) && !noActions &&
                    <Button type="submit" onClick={handleSave}
                            className={`Save_btn ${ready ? "valid-btn" : "invalid-btn"} ${(withoutCancel || reverseButtons) ? "float-right" : ""}`}
                            variant="primary">{saveButton ? saveButton : t("common.save")}</Button>
                }
                {!withoutCancel && !readOnly && (reInit ? editMode : true) && !noActions &&
                    <Button className={` Reset_btn ${reverseButtons ? "float-left" : "float-right"}`}
                            variant="outline-secondary"
                            onClick={onCancel}

                    >
                        <i className="fas fa-times"/>&nbsp;{t("common.cancel")}
                    </Button>
                }
            </CustomCard>

            <ConfirmModal
                title={t("forms.all_fields_required")}
                description={t("forms.fill_red_fields")}
                size={"md"}
                show={showAllerModal}
                setShow={setShowAllerModal}
                alert
                onConfirm={() => setShowAllerModal(false)}
            />

        </>
    );
};


export default CardForm;